export const pushTarif = (res) => {
  const dataTarif = [];
  const dataFormTarif = [];

  if (res) {
    res.map((e) => {
      dataTarif.push({
        id: e.id,
        name: e.name,
        label: `HARGA JUAL ${e.name.toUpperCase()}`,
      });

      dataFormTarif.push({
        id_tarif: e.id,
        id_jasa: e.id_jasa,

        harga: 0,
        harga2: "",
      });

      return true;
    });
  }

  return {
    dataTarif,
    dataFormTarif,
  };
};

export const pushJasaTarif = (res) => {
  const dataTarif = [];
  const dataFormTarifBeli = [];
  const dataFormTarifJual = [];

  if (res) {
    res.map((e) => {
      dataTarif.push({
        id: e.id,
        name: e.name,
        label: `${e.name.toUpperCase()}`,
      });

      dataFormTarifBeli.push({
        id_tarif: e.id,
        id_jasa: e.id_jasa,

        harga_beli: 0,
        harga_beli2: "",
      });

      dataFormTarifJual.push({
        id_tarif: e.id,
        id_jasa: e.id_jasa,

        harga_jual: 0,
        harga_jual2: "",
      });

      return true;
    });
  }

  return {
    dataTarif,
    dataFormTarifBeli,
    dataFormTarifJual,
  };
};

export const WarningMasterPenjualan = () => {
  return (
    <ul
      style={{
        fontSize: "11px",
        marginTop: "2rem",
      }}>
      <li>
        Button simpan digunakan untuk mengupdate harga sesuai dengan jenis harga
      </li>
      <li>
        Button update all digunakan untuk mengupdate harga pada semua jenis
        harga
      </li>
    </ul>
  );
};
